
import { defuFn } from '/home/forge/juleica.de/releases/20251006133937/client-frontend/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/home/forge/juleica.de/releases/20251006133937/client-frontend/nuxt-core/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
